// extracted by css-extract-rspack-plugin
export default {"cls1":"TransactionalPricingModal-cls1_2NA","cls2":"TransactionalPricingModal-cls2_z02 TransactionalPricingModal-cls1_2NA"};